import protoRoot from "../proto-root";
import CameraRecordingStatus from "../private/CameraRecordingStatus";

const name = "setCameraVideoRecordingRPCResponse";

function create({ result, status }: { result: "SUCCESS" | "FAILURE"; status: CameraRecordingStatus }) {
  const SetCameraVideoRecordingRPCResponse = protoRoot.lookupType("comm.SetCameraVideoRecordingRPCResponse");
  const ResultEnum = protoRoot.lookupEnum("Result");

  const payload = SetCameraVideoRecordingRPCResponse.create({
    result: ResultEnum.values[result],
    status: CameraRecordingStatus.create(status)
  });

  return { payload, name };
}

const setCameraVideoRecordingRpcResponse = { create, name };

export default setCameraVideoRecordingRpcResponse;
